export default __webpack_public_path__ + "static/media/WhitePDFIconForDarkMode.c4197434.svg";